import { DEFAULT_PLACEHOLDER } from '@constants/generic';
import { PaymentCollectionType } from '@features/group-management/constants';
import { formatDueDatePlaceholder } from '@features/group-management/helper';
import { AddFromMembersListItem } from '@features/group-management/types';

interface DueDateSelectorProps {
  groupPaymentCollectionType: PaymentCollectionType;
  setSelectedMemberId: (id: string) => void;
  setIsCalendarVisible: (visible: boolean) => void;
  row: AddFromMembersListItem;
}

const DueDateSelector = ({
  groupPaymentCollectionType,
  setSelectedMemberId,
  setIsCalendarVisible,
  row
}: DueDateSelectorProps) => {
  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    e.preventDefault();
    if (groupPaymentCollectionType !== PaymentCollectionType.ONCE) {
      setSelectedMemberId(row.id);
      setIsCalendarVisible(true);
    }
  };

  return (
    <div
      className="flex h-12.5 w-full min-w-40 max-w-60 items-center justify-center truncate rounded-lg border border-cofeeNeutral5 bg-cofeeNeutral1 p-2.5 px-4 font-normal"
      role="presentation"
      onClick={handleClick}
      id="due-date-selector"
    >
      {row.dueDate
        ? (formatDueDatePlaceholder(
            row.paymentCollectionType as PaymentCollectionType,
            Number(row.interval),
            row.dueDate
          ) as string)
        : DEFAULT_PLACEHOLDER}
    </div>
  );
};

export default DueDateSelector;
